import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
import { initialFromDate } from '@/utils/utils';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  workStartPaginateData: {
    page: 0,
    totalItems: 0,
    items: null,
  },
  workStartDetail: null,
  takeoffLandingData: {
    page: 0,
    totalItems: 0,
    items: null,
  },
  groundingData: {
    page: 0,
    totalItems: 0,
    items: null,
  },
  helicopterReplacementData: {
    page: 0,
    totalItems: 0,
    items: null,
  },
  refuelData: {
    page: 0,
    totalItems: 0,
    items: null,
  },
};
const getters = {
  getApiLoad_2: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_phoneActivityWorkStartData(state, workStartPaginateData) {
    state.workStartPaginateData = workStartPaginateData;
  },
  SET_phoneActivityWorkStartDetail(state, workStarDetail) {
    state.workStartDetail = workStarDetail;
  },
  SET_TakeoffLandingData(state, takeoffLandingData) {
    state.takeoffLandingData = takeoffLandingData;
  },
  SET_GroundingData(state, groundingData) {
    state.groundingData = groundingData;
  },
  SET_helicopterReplacementData(state, helicopterReplacementData) {
    state.helicopterReplacementData = helicopterReplacementData;
  },
  SET_RefuelData(state, refuelData) {
    state.refuelData = refuelData;
  },
};
const actions = {
  onError({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getPhoneActivityWorkStartListDispatch({ commit, dispatch, rootState }, params) {
    const customParams = {
      ...params,
      fromDate: initialFromDate(params?.fromDate),
    };
    return apiClient
      .get('/AirAmbulances/PhoneActivityWorkStartFormPagination', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params: customParams,
      })
      .then((response) => {
        commit('SET_phoneActivityWorkStartData', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('onError', error);
      });
  },
  getPhoneActivityWorkStartDetailDispatch({ commit, dispatch, rootState }, params) {
    const customParams = {
      ...params,
      fromDate: initialFromDate(params?.fromDate),
    };
    return apiClient
      .get('/AirAmbulances/PhoneActivityWorkStartForm', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params: customParams,
      })
      .then((response) => {
        commit('SET_phoneActivityWorkStartDetail', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('onError', error);
      });
  },
  getTakeoffLandingListDispatch({ commit, dispatch, rootState }, params) {
    const customParams = {
      ...params,
      fromDate: initialFromDate(params?.fromDate),
    };
    return apiClient
      .get('/AirAmbulances/TakeoffLandingPagination', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params: customParams,
      })
      .then((response) => {
        commit('SET_TakeoffLandingData', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('onError', error);
      });
  },
  getGroundingListDispatch({ commit, dispatch, rootState }, params) {
    const customParams = {
      ...params,
      fromDate: initialFromDate(params?.fromDate),
    };
    return apiClient
      .get('/AirAmbulances/GroundingPagination', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params: customParams,
      })
      .then((response) => {
        commit('SET_GroundingData', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('onError', error);
      });
  },
  getHelicopterReplacementDispatch({ commit, dispatch, rootState }, params) {
    const customParams = {
      ...params,
      fromDate: initialFromDate(params?.fromDate),
    };
    return apiClient
      .get('/AirAmbulances/HelicopterReplacementPagination', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params: customParams,
      })
      .then((response) => {
        commit('SET_helicopterReplacementData', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('onError', error);
      });
  },
  getRefuelDataDispatch({ commit, dispatch, rootState }, params) {
    const customParams = {
      ...params,
      fromDate: initialFromDate(params?.fromDate),
    };
    return apiClient
      .get('/AirAmbulances/RefuelPagination', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        params: customParams,
      })
      .then((response) => {
        commit('SET_RefuelData', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('onError', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
